function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCloudy1 = function SvgCloudy1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 481.306 481.306",
    style: {
      enableBackground: "new 0 0 481.306 481.306"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCB641"
    },
    cx: 341.632,
    cy: 233.229,
    rx: 136,
    ry: 133.456
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M336,65.453c-4.416,0-8-3.584-8-8v-48c0-4.416,3.584-8,8-8s8,3.584,8,8v48 C344,61.869,340.416,65.453,336,65.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M439.36,98.757c-2.048,0-4.096-0.784-5.656-2.344c-3.128-3.128-3.128-8.184,0-11.312l33.944-33.944 c3.128-3.128,8.184-3.128,11.312,0s3.128,8.184,0,11.312l-33.944,33.944C443.456,97.973,441.408,98.757,439.36,98.757z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB641"
    },
    d: "M208.968,122.421c-2.048,0-4.096-0.784-5.656-2.344l-33.936-33.936 c-3.128-3.128-3.128-8.184,0-11.312s8.184-3.128,11.312,0l33.936,33.936c3.128,3.128,3.128,8.184,0,11.312 C213.064,121.637,211.016,122.421,208.968,122.421z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M426.208,361.453c-1.12,0-42.648,0-42.648,0c0.744-8,1.24-8.688,1.256-13.472 c0.128-42.672-28.36-79.952-70.032-89.136c-23.752-5.232-46.424-1.368-65.184,8.76c-22.888-34.064-60.808-57.04-104.272-59.696 c-5.592-0.768-11.256-1.224-17.056-1.224C57.432,206.685,0,265.949,0,339.005c0,38.072,15.688,72.304,40.648,96.44 c22.072,24.488,52.72,40.312,89.008,42.944c0,0,295.432,1.464,296.552,1.464c29.712,0,53.792-27.208,53.792-59.208 C480,388.661,455.912,361.453,426.208,361.453z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloudy1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloudy-1.cfb1e955.svg";
export { ForwardRef as ReactComponent };